// Friendly closing message for the egresado when the empresa does not advance (internal motivo never shown).
export const ProcesoFinalizado = ({ id, onVerOfertas }) => (
  <div className="w-full border-t border-slate-100 pt-3" data-testid={`post-finalizado-${id}`}>
    <p className="text-sm text-[var(--brand-text-muted)]">
      Esta búsqueda ya cerró su proceso de selección. ¡Gracias por postularte! Te dejamos otras oportunidades que pueden interesarte.
    </p>
    <button type="button" onClick={onVerOfertas} className="btn-outline text-xs mt-3" data-testid={`post-ver-similares-${id}`}>
      Ver ofertas similares
    </button>
  </div>
);
